import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Page from 'components/Page'
import content from 'prismic-translates/page-identity-verification.json'

const t = getTranslationFromJson([content])

function UnautorizedRoute() {
  return (
    <Page>
      <h4 className='mt-typography-h4 mt-typography-alignCenter '>{t('unautorized_route_msg')}</h4>
    </Page>
  )
}

export default UnautorizedRoute
